var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.showPreviewImg)?_c('vue-picture-viewer',{attrs:{"img-data":_vm.previewImgs,"select-index":_vm.previewIndex},on:{"close-viewer":function($event){_vm.showPreviewImg=false}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }